<div class="bi-snackbar__label" matSnackBarLabel>
  <mat-icon class="bi-snackbar__message-icon" aria-hidden="true">{{ messageIconName }}</mat-icon>
  <span class="bi-snackbar__message-text">{{ data.message }}</span>
</div>
<span matSnackBarActions class="bi-snackbar__actions">
  <button
    type="button"
    matIconButton
    matSnackBarAction
    class="bi-snackbar__close"
    [attr.aria-label]="closeAriaLabel"
    (click)="dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</span>
